
const SvgIconStar = (props) => (
  <svg width="14" height="15" viewBox="0 0 14 15" {...props}>
    <path d="M7 0.5L8.65248 5.84752H14L9.67376 9.15248L11.3262 14.5L7 11.195L2.67376 14.5L4.32624 9.15248L0 5.84752H5.34752L7 0.5Z" fill="#F05F40" />
  </svg>
);

export default SvgIconStar;
